import { connect } from "react-redux";
import Component from "./Header";

export default connect(
      ({ auth: { loggedIn, user } }) => ({ loggedIn, user }),
      ({ auth: { logout } }) => ({ logout })
)(Component);
